<template>
  <div class="main-layout">
    <slot class="navigation" name="navigation"></slot>

    <div class="content">
      <slot name="content"></slot>
    </div>
    <slot class="footer" name="footer"></slot>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  /* background-color: black; */
  color: white;
}
.content {
  /* margin: auto; */
  /* max-width: 1200px; */
}


@media (max-width: 1024px) {
  /* .content {
    margin-top: 54px !important;
  } */
}
</style>
